module.exports = __webpack_public_path__ + "img/_cdq2b160-40dc-a73.prt.2b55e6fb.jpg";